import { Component, input } from '@angular/core';

@Component({
  selector: 'app-powered-by-vana',
  imports: [],
  templateUrl: './powered-by-vana.html',
  styleUrl: './powered-by-vana.scss',
})
export class PoweredByVanaComponent {
  readonly compact = input(false);
}
